import { render, staticRenderFns } from "./ProductImpressions.vue?vue&type=template&id=5cc14d60"
import script from "./ProductImpressions.vue?vue&type=script&lang=js"
export * from "./ProductImpressions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports